import { formatNumberWithCommas } from "@helpers/formatNumber";

/**
 * @param {object|undefined} ticker — entry from futures tickersMap
 * @returns {{ lastPrice: number|null, changePercent: number|null }}
 */
export const parseTicker = (ticker) => ({
  lastPrice: ticker?.lastPrice ? parseFloat(ticker.lastPrice) : null,
  changePercent: ticker?.priceChangePercent
    ? parseFloat(ticker.priceChangePercent)
    : null,
});

/**
 * @param {number|null} price
 * @returns {string}
 */
export const formatPrice = (price) =>
  price !== null ? `$${formatNumberWithCommas(price)}` : "...";

/**
 * @param {number} percent
 * @returns {string}
 */
export const formatChange = (percent) =>
  `${percent >= 0 ? "+" : ""}${formatNumberWithCommas(percent)}%`;
